<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ title }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Username</span>
        <input class="text-box-active" formControlName="userName" />
        @if(!isEdit && usernameCheck.message){
        <span
          class="field-message"
          [class.field-error]="usernameCheck.status === 'taken' || usernameCheck.status === 'short'"
          [class.field-success]="usernameCheck.status === 'available'"
        >
          {{ usernameCheck.message }}
        </span>
        }
      </div>
      @if(isEdit){
      <div class="field"><span class="field-label">Full name</span><input class="text-box-active" formControlName="fullName" /></div>
      } @else {
      <div class="field">
        <span class="field-label">Family code</span>
        <input class="text-box-active" formControlName="familyCode" inputmode="numeric" maxlength="12" (input)="onFamilyCodeInput()" />
        @if(memberLookup.isLoading){ <span class="field-message">Finding members…</span> }
      </div>
      }
    </div>
    <div class="field-row">
      @if(!isEdit){
      <div class="field">
        <span class="field-label">Name</span>
        <mat-form-field appearance="outline">
          <mat-select
            formControlName="memUuid"
            [placeholder]="memberLookup.loaded ? 'Select the person' : 'Enter the family code first'"
            (selectionChange)="onMemberPick($event.value)"
          >
            @for(m of memberLookup.members; track $index){
            <mat-option [value]="m.memUuid" [disabled]="!m.memUuid">
              {{ m.fullName }}
            </mat-option>
            } @empty {
            <mat-option [value]="''" disabled>
              {{ memberLookup.loaded ? 'No members found.' : 'Enter the 12-digit family code.' }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if(memberLookup.pickMessage){
        <span class="field-message" [class.field-error]="memberLookup.pickStatus === 'taken'">
          {{ memberLookup.pickMessage }}
        </span>
        }
      </div>
      }
      <div class="field">
        <span class="field-label">Role</span>
        <mat-form-field appearance="outline">
          <mat-select formControlName="roleKey" [placeholder]="isEdit ? 'Keep current role' : 'Select a role'">
            @if(isEdit){ <mat-option [value]="''">Keep current role</mat-option> }
            @for(r of roles; track r.roleKey){ <mat-option [value]="r.roleKey">{{ r.roleName }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
      @if(isEdit){
      <div class="field"><span class="field-label">Family code</span><input class="text-box-active" formControlName="familyCode" /></div>
      }
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Mobile number</span><input class="text-box-active" formControlName="mobileNumber" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Email</span><input class="text-box-active" formControlName="emailId" /></div>
      <div class="field"><span class="field-label">Identity number</span><input class="text-box-active" formControlName="identityNumber" /></div>
    </div>
    @if(isEdit){
    <p class="dialog-note">Username and the SSO identity belong to the sign-in account, so they cannot change here.</p>
    }
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">{{ isEdit ? 'Save' : 'Add' }}</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
